import { CommandBar } from "@fluentui/react/lib/CommandBar";
import { useState, useEffect } from "react";

import { useSelector } from "react-redux";
import { selectIsAutoRefresh, selectIsLoading, selectIsToolbarIconsOnly } from "Store/Selectors/UI";
import { WithConfiguration } from "Components/Generic/Configuration";
import { EntityType } from "Model/EntityType";
import { useToolbar } from "./UseToolbar";
import { DURATION_MS, useToolbarStyles } from "./UseToolbarStyles";
import { IToolbarProps } from "./IToolbarProps";

export const Toolbar = WithConfiguration((props: IToolbarProps): JSX.Element => {
  const { type = EntityType.None, config } = props;
  const isIconsOnly = useSelector(selectIsToolbarIconsOnly);
  const isLoading = useSelector(selectIsLoading);
  const isAutoRefresh = useSelector(selectIsAutoRefresh);
  const [showSpinningRefresh, setShowSpinningRefresh] = useState(isLoading || isAutoRefresh);

  useEffect(() => {
    let timeout: number;
    const isSpinning = isLoading || isAutoRefresh;

    if (isSpinning === true) {
      window.clearTimeout(timeout);
      setShowSpinningRefresh(isSpinning);
    } else if (isSpinning === false) {
      timeout = window.setTimeout(() => {
        setShowSpinningRefresh(false);
      }, DURATION_MS);
    }

    return () => {
      window.clearTimeout(timeout);
    };
  }, [isLoading, isAutoRefresh]);

  const generateItems = useToolbar(type);
  const toolbarItems = generateItems(config.getToolbar(isIconsOnly));
  const overflowItems = isIconsOnly ? [] : generateItems(config.getToolbarOverflow());

  const styles = useToolbarStyles(showSpinningRefresh);
  return <CommandBar className={styles.toolbar} items={toolbarItems} overflowItems={overflowItems} />;
});

Toolbar.displayName = `Toolbar`;
